<template>
  <div class="columns">
    <div class="column is-12">
      <div class="digital-clock">
        <div class="digital-clock-legs">
          <div
            class="digital-clock-leg middle-leg"
            :style="clockLegStyles"
          ></div>
        </div>
        <div class="clock-inside" :style="clockStyles">
          <div class="time-part">{{ clockTime }}</div>
        </div>
        <div class="digital-clock-legs px-3">
          <div
            class="digital-clock-leg right-leg"
            :style="clockLegStyles"
          ></div>
          <div class="digital-clock-leg left-leg" :style="clockLegStyles"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCSSFromStyles } from "@/components/Common/StyleEditor/utils";
export default {
  name: "digital-clock",
  props: {
    clock: {
      type: Object,
      required: true,
    },
  },
  computed: {
    clockStyles() {
      let styles = {};
      if (this.clock.digital && this.clock.digital.styles) {
        styles = getCSSFromStyles(this.clock.digital.styles);
      }

      return styles;
    },
    clockLegStyles() {
      if (this.clockStyles["border-color"]) {
        return {
          "background-color": `${this.clockStyles["border-color"]}!important`,
        };
      }
      return {};
    },
    clockTime() {
      let times = [];
      if (!this.clock.is_hour_hidden) {
        times.push(this.padStart(this.clock.hour));
      }
      if (!this.clock.is_minute_hidden) {
        times.push(this.padStart(this.clock.minute));
      }
      if (!this.clock.is_second_hidden) {
        times.push(this.padStart(this.clock.second));
      }
      let time_string = times.join(" : ");
      return time_string;
    },
  },
  methods: {
    padStart(time_part) {
      if (!time_part) {
        time_part = 0;
      }
      return time_part.toString().padStart(2, "0");
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@500&display=swap");
.time-part {
  font-size: 30px;
  padding: 5px;
  float: left;
  font-family: "Orbitron", sans-serif;
}
.digital-clock {
  float: left;
}
.digital-clock > .clock-inside {
  background-color: #fff;
  border: 10px solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  border-width: 10px !important;
}

.digital-clock-leg {
  width: 30%;
  height: 15px;
  background: #000;
  top: -5px;
  position: relative;
}
.left-leg {
  float: left;
}
.right-leg {
  float: right;
}
.middle-leg {
  margin: auto;
  top: 5px;
}
</style>